// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* B2C host: Prediction Market is a normal document page that scrolls with the site. */

body.prediction-market-open {
  overflow-x: hidden;
  overflow-y: auto;
      background: radial-gradient(120% 80% at 50% -20%, rgb(var(--pm-gold) / 0.16), transparent 55%), rgb(var(--color-surface));
}

body.prediction-market-open header.header,
body.prediction-market-open header {
  z-index: 1100;
  width: 100%;
}

body.prediction-market-open header.header.header-popup-open,
body.prediction-market-open.header-popup-open header.header {
  z-index: 2100;
}

body.header-popup-open .prediction-market-page,
body.header-popup-open .prediction-market-layout,
body.header-popup-open .content-wrapper {
  pointer-events: none;
}

body.header-popup-open .market-orders-indicator__dropdown {
  visibility: hidden !important;
  opacity: 0 !important;
  pointer-events: none !important;
}

body.prediction-market-open .header-toggle-icon,
body.prediction-market-open .sidebar-wrap,
body.prediction-market-open .Mobile-bottom-bar {
  display: none !important;
}

.pm-header-actions {
  display: flex !important;
  align-items: center;
  gap: 0.5rem;
  margin-right: 0.75rem;
  position: relative;
  z-index: 20;
  flex-shrink: 0;
}

header .header-right {
  position: relative;
  z-index: 21;
}

.pm-header-actions .header-icon-btn,
.pm-header-actions .notification-bell__trigger,
.pm-header-actions .market-orders-indicator__trigger {
  width: 2.5rem !important;
  height: 2.5rem !important;
  min-width: 2.5rem;
  min-height: 2.5rem;
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  background: var(--gray-80) !important;
  border: 1px solid var(--gray-60) !important;
  color: #efd43c !important;
  opacity: 1 !important;
  visibility: visible !important;
}

.pm-header-actions .header-icon-btn:hover,
.pm-header-actions .notification-bell__trigger:hover,
.pm-header-actions .market-orders-indicator__trigger:hover {
  border-color: #cb7d00 !important;
  color: #fcd443 !important;
}

.pm-header-actions svg {
  width: 16px;
  height: 16px;
  display: block;
  fill: currentColor;
}

.pm-header-actions .market-orders-indicator__trigger--active svg {
  animation: market-orders-indicator-spin 1s linear infinite;
}

.pm-header-actions .notification-bell__trigger svg path {
  fill: #efd43c;
}

/* Subnav container layout lives in Tailwind on Header (relative mx-auto max-w-[1400px]). */

body.prediction-market-open .page-container.prediction-market-layout,
body.prediction-market-open .page-container {
  margin-left: 0 !important;
  padding-bottom: 0 !important;
  padding-right: 0 !important;
  width: 100%;
}

body.prediction-market-open .content-wrapper,
body.prediction-market-open .content-wrapper.prediction-market-wrap {
  margin: 3.4375rem 0 0 !important;
  padding: 0 !important;
  max-width: none !important;
  min-height: calc(100vh - 3.4375rem) !important;
  width: 100%;
}

body.prediction-market-open .prediction-market-page {
  --pm-site-header: 76px;
  --pm-header-offset: 0px;
  position: relative;
  inset: auto;
  top: auto;
  right: auto;
  bottom: auto;
  left: auto;
  width: 100%;
  height: auto;
  min-height: calc(100vh - var(--pm-site-header));
  max-width: none;
  overflow: visible;
  z-index: 1;
}

body.prediction-market-open .prediction-market-main {
  padding-top: 0;
  overflow: visible;
}

body.prediction-market-open .header-section {
  position: relative;
  top: auto;
  z-index: 20;
}

body.prediction-market-open .prediction-market-page .market-detail-wrapper {
  max-height: none;
  overflow: visible;
}

body.prediction-market-open .prediction-market-page .market-detail-order-panel-wrap {
  top: calc(var(--pm-site-header) + 12px);
}

body.prediction-market-open .prediction-market-page .sub-filter-bar,
body.prediction-market-open .prediction-market-page .sub-filter-item,
body.prediction-market-open .prediction-market-page .market-detail-trade-fab,
body.prediction-market-open .prediction-market-page .how-it-works-panel,
body.prediction-market-open .prediction-market-page .common-popup,
body.prediction-market-open .prediction-market-page .wallet-activity-modal,
body.prediction-market-open .prediction-market-page .portfolio-tabs-card,
body.prediction-market-open .prediction-market-page .notification-bell__dropdown,
body.prediction-market-open .prediction-market-page .market-orders-indicator__dropdown {
  border-radius: var(--pm-radius, 8px);
}

body.prediction-market-open .prediction-market-page .order-panel-outcome-btn,
body.prediction-market-open .prediction-market-page .order-panel-stepper,
body.prediction-market-open .prediction-market-page .order-panel-market-tab-summary,
body.prediction-market-open .prediction-market-page .order-panel-limit-tab-summary,
body.prediction-market-open .prediction-market-page .order-panel-disabled-note {
  border-radius: var(--pm-radius-sm, 6px);
}

body.prediction-market-open .prediction-market-page .prediction-market-content--breaking {
  width: 100%;
  max-width: none;
  margin-top: 0;
}

body.prediction-market-open .prediction-market-page .breaking-markets {
  min-height: calc(100vh - var(--pm-site-header, 76px) - 80px);
}

body.prediction-market-open .prediction-market-page .breaking-markets-main {
  max-height: calc(100vh - var(--pm-site-header, 76px) - 280px);
}

body.prediction-market-open .prediction-market-page .breaking-markets-order-wrap {
  --order-panel-max-h: calc(100vh - var(--pm-site-header, 76px) - 280px);
}

body.prediction-market-open .dark .prediction-market-page .header-section {
  background: rgb(var(--color-surface) / 0.96);
}

@media (max-width: 575.98px) {
  body.prediction-market-open .content-wrapper,
  body.prediction-market-open .content-wrapper.prediction-market-wrap {
    margin-top: 64px !important;
    min-height: calc(100vh - 64px) !important;
  }

  body.prediction-market-open .prediction-market-page {
    --pm-site-header: 64px;
    min-height: calc(100vh - 64px);
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/prediction-market-embed.css"],"names":[],"mappings":"AAAA,sFAAsF;;AAEtF;EACE,kBAAkB;EAClB,gBAAgB;MACZ,yHAAyH;AAC/H;;AAEA;;EAEE,aAAa;EACb,WAAW;AACb;;AAEA;;EAEE,aAAa;AACf;;AAEA;;;EAGE,oBAAoB;AACtB;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA;;;EAGE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;;;EAGE,wBAAwB;EACxB,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,+BAA+B;EAC/B,mBAAmB;EACnB,uBAAuB;EACvB,qCAAqC;EACrC,2CAA2C;EAC3C,yBAAyB;EACzB,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA;;;EAGE,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,0DAA0D;AAC5D;;AAEA;EACE,aAAa;AACf;;AAEA,2FAA2F;;AAE3F;;EAEE,yBAAyB;EACzB,4BAA4B;EAC5B,2BAA2B;EAC3B,WAAW;AACb;;AAEA;;EAEE,gCAAgC;EAChC,qBAAqB;EACrB,0BAA0B;EAC1B,8CAA8C;EAC9C,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,WAAW;EACX,YAAY;EACZ,UAAU;EACV,WAAW;EACX,YAAY;EACZ,+CAA+C;EAC/C,eAAe;EACf,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;;;;;;;;;EASE,oCAAoC;AACtC;;AAEA;;;;;EAKE,uCAAuC;AACzC;;AAEA;EACE,WAAW;EACX,eAAe;EACf,aAAa;AACf;;AAEA;EACE,4DAA4D;AAC9D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,sEAAsE;AACxE;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE;;IAEE,2BAA2B;IAC3B,yCAAyC;EAC3C;;EAEA;IACE,sBAAsB;IACtB,8BAA8B;EAChC;AACF","sourcesContent":["/* B2C host: Prediction Market is a normal document page that scrolls with the site. */\n\nbody.prediction-market-open {\n  overflow-x: hidden;\n  overflow-y: auto;\n      background: radial-gradient(120% 80% at 50% -20%, rgb(var(--pm-gold) / 0.16), transparent 55%), rgb(var(--color-surface));\n}\n\nbody.prediction-market-open header.header,\nbody.prediction-market-open header {\n  z-index: 1100;\n  width: 100%;\n}\n\nbody.prediction-market-open header.header.header-popup-open,\nbody.prediction-market-open.header-popup-open header.header {\n  z-index: 2100;\n}\n\nbody.header-popup-open .prediction-market-page,\nbody.header-popup-open .prediction-market-layout,\nbody.header-popup-open .content-wrapper {\n  pointer-events: none;\n}\n\nbody.header-popup-open .market-orders-indicator__dropdown {\n  visibility: hidden !important;\n  opacity: 0 !important;\n  pointer-events: none !important;\n}\n\nbody.prediction-market-open .header-toggle-icon,\nbody.prediction-market-open .sidebar-wrap,\nbody.prediction-market-open .Mobile-bottom-bar {\n  display: none !important;\n}\n\n.pm-header-actions {\n  display: flex !important;\n  align-items: center;\n  gap: 0.5rem;\n  margin-right: 0.75rem;\n  position: relative;\n  z-index: 20;\n  flex-shrink: 0;\n}\n\nheader .header-right {\n  position: relative;\n  z-index: 21;\n}\n\n.pm-header-actions .header-icon-btn,\n.pm-header-actions .notification-bell__trigger,\n.pm-header-actions .market-orders-indicator__trigger {\n  width: 2.5rem !important;\n  height: 2.5rem !important;\n  min-width: 2.5rem;\n  min-height: 2.5rem;\n  display: inline-flex !important;\n  align-items: center;\n  justify-content: center;\n  background: var(--gray-80) !important;\n  border: 1px solid var(--gray-60) !important;\n  color: #efd43c !important;\n  opacity: 1 !important;\n  visibility: visible !important;\n}\n\n.pm-header-actions .header-icon-btn:hover,\n.pm-header-actions .notification-bell__trigger:hover,\n.pm-header-actions .market-orders-indicator__trigger:hover {\n  border-color: #cb7d00 !important;\n  color: #fcd443 !important;\n}\n\n.pm-header-actions svg {\n  width: 16px;\n  height: 16px;\n  display: block;\n  fill: currentColor;\n}\n\n.pm-header-actions .market-orders-indicator__trigger--active svg {\n  animation: market-orders-indicator-spin 1s linear infinite;\n}\n\n.pm-header-actions .notification-bell__trigger svg path {\n  fill: #efd43c;\n}\n\n/* Subnav container layout lives in Tailwind on Header (relative mx-auto max-w-[1400px]). */\n\nbody.prediction-market-open .page-container.prediction-market-layout,\nbody.prediction-market-open .page-container {\n  margin-left: 0 !important;\n  padding-bottom: 0 !important;\n  padding-right: 0 !important;\n  width: 100%;\n}\n\nbody.prediction-market-open .content-wrapper,\nbody.prediction-market-open .content-wrapper.prediction-market-wrap {\n  margin: 3.4375rem 0 0 !important;\n  padding: 0 !important;\n  max-width: none !important;\n  min-height: calc(100vh - 3.4375rem) !important;\n  width: 100%;\n}\n\nbody.prediction-market-open .prediction-market-page {\n  --pm-site-header: 76px;\n  --pm-header-offset: 0px;\n  position: relative;\n  inset: auto;\n  top: auto;\n  right: auto;\n  bottom: auto;\n  left: auto;\n  width: 100%;\n  height: auto;\n  min-height: calc(100vh - var(--pm-site-header));\n  max-width: none;\n  overflow: visible;\n  z-index: 1;\n}\n\nbody.prediction-market-open .prediction-market-main {\n  padding-top: 0;\n  overflow: visible;\n}\n\nbody.prediction-market-open .header-section {\n  position: relative;\n  top: auto;\n  z-index: 20;\n}\n\nbody.prediction-market-open .prediction-market-page .market-detail-wrapper {\n  max-height: none;\n  overflow: visible;\n}\n\nbody.prediction-market-open .prediction-market-page .market-detail-order-panel-wrap {\n  top: calc(var(--pm-site-header) + 12px);\n}\n\nbody.prediction-market-open .prediction-market-page .sub-filter-bar,\nbody.prediction-market-open .prediction-market-page .sub-filter-item,\nbody.prediction-market-open .prediction-market-page .market-detail-trade-fab,\nbody.prediction-market-open .prediction-market-page .how-it-works-panel,\nbody.prediction-market-open .prediction-market-page .common-popup,\nbody.prediction-market-open .prediction-market-page .wallet-activity-modal,\nbody.prediction-market-open .prediction-market-page .portfolio-tabs-card,\nbody.prediction-market-open .prediction-market-page .notification-bell__dropdown,\nbody.prediction-market-open .prediction-market-page .market-orders-indicator__dropdown {\n  border-radius: var(--pm-radius, 8px);\n}\n\nbody.prediction-market-open .prediction-market-page .order-panel-outcome-btn,\nbody.prediction-market-open .prediction-market-page .order-panel-stepper,\nbody.prediction-market-open .prediction-market-page .order-panel-market-tab-summary,\nbody.prediction-market-open .prediction-market-page .order-panel-limit-tab-summary,\nbody.prediction-market-open .prediction-market-page .order-panel-disabled-note {\n  border-radius: var(--pm-radius-sm, 6px);\n}\n\nbody.prediction-market-open .prediction-market-page .prediction-market-content--breaking {\n  width: 100%;\n  max-width: none;\n  margin-top: 0;\n}\n\nbody.prediction-market-open .prediction-market-page .breaking-markets {\n  min-height: calc(100vh - var(--pm-site-header, 76px) - 80px);\n}\n\nbody.prediction-market-open .prediction-market-page .breaking-markets-main {\n  max-height: calc(100vh - var(--pm-site-header, 76px) - 280px);\n}\n\nbody.prediction-market-open .prediction-market-page .breaking-markets-order-wrap {\n  --order-panel-max-h: calc(100vh - var(--pm-site-header, 76px) - 280px);\n}\n\nbody.prediction-market-open .dark .prediction-market-page .header-section {\n  background: rgb(var(--color-surface) / 0.96);\n}\n\n@media (max-width: 575.98px) {\n  body.prediction-market-open .content-wrapper,\n  body.prediction-market-open .content-wrapper.prediction-market-wrap {\n    margin-top: 64px !important;\n    min-height: calc(100vh - 64px) !important;\n  }\n\n  body.prediction-market-open .prediction-market-page {\n    --pm-site-header: 64px;\n    min-height: calc(100vh - 64px);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
